import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
`;
